import QueueStatusPage from '../pages/QueueStatusPage.vue'

export default [
  {
    name: 'QueueStatus',
    path: '/system/queue/status',
    component: QueueStatusPage,
    meta: {
      auth: ['viewProjectTechnical'],
      title: 'QueueStatusPage_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/system/router/index.js